export enum NOTIFICATION_TYPES {
    ERROR = 'error',
    SUCCESS = 'success',
    INFORMATION = 'information',
    INFORMATION_V2 = 'information-v2',
}

export enum NOTIFICATION_ROLES {
    ALERT = 'alert',
    STATUS = 'status',
}

export enum NOTIFICATION_LIVE {
    ASSERTIVE = 'assertive',
    POLITE = 'polite',
}
